const accountRecoveryConfirmPasswordMessagesTemplate = `
<ng-messages
    for="getFieldError('confirmPassword');"
    ng-if="displayFieldMessages('confirmPassword');"
    class="rule-validations"
>
    <ng-message when="required">
        <span ng-class="{'text-muted': focusMgr['confirmPassword']}"> {{ ::translatedData.confirmPasswordRequired }}</span>
    </ng-message>

    <ng-message when="compareTo">
        <span ng-class="{'text-muted': focusMgr['confirmPassword']}"> {{ ::translatedData.confirmPasswordNotMatch }}</span>
    </ng-message>
    <ng-message when="!(compareTo)">
        <span ng-class="{'text-muted': focusMgr['confirmPassword']}"> {{ ::translatedData.confirmPasswordValid }}</span>
    </ng-message>
</ng-messages>
`;
export default accountRecoveryConfirmPasswordMessagesTemplate;
